import { isExpired, decodeToken } from "react-jwt";
import { JWT } from "../constants/types";

const decodeJwt = (token: string): JWT | null => {
  try {
    if (!token) {
      return null;
    }
    return decodeToken(token);
  } catch {
    return null;
  }
};

const isJwtExpired = (token: string): boolean => {
  try {
    if (!token) {
      return true;
    }
    return isExpired(token);
  } catch {
    return true;
  }
};

export { decodeJwt, isJwtExpired };
